import { inject, Injectable } from "@angular/core";

import type { BaseFilterDefinition, FilterValue } from "@filter/filter.types";
import type { JobsBillingCard, TranslateObject } from "@app/views-interfaces";
import { TaxReturnStatusesService } from "@shared/tax-return-statuses-service";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

@Injectable()
export class JobStatusFilterService extends SimpleFilterMulti<JobsBillingCard> {
    private readonly taxReturnStatusesService = inject(TaxReturnStatusesService);

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "JobStatus",
            label: "AllView.JobStatus",
        };
    }

    protected getValue(item: JobsBillingCard): FilterValue | undefined {
        return item.job?.statusId;
    }

    protected getLabel(statusId: string): string | undefined | null | TranslateObject {
        return this.taxReturnStatusesService.currentTaxReturnStatuses()?.find((item) => item.Id === statusId)?.Name;
    }

    protected getAllValues(): readonly string[] {
        return this.taxReturnStatusesService.currentTaxReturnStatuses()?.flatMap((status) => (status.Id ? [status.Id] : [])) ?? [];
    }
}
